import { render, staticRenderFns } from "./VenueTrainingList.vue?vue&type=template&id=91476428"
import script from "./VenueTrainingList.vue?vue&type=script&lang=js"
export * from "./VenueTrainingList.vue?vue&type=script&lang=js"
import style0 from "./VenueTrainingList.vue?vue&type=style&index=0&id=91476428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports